module.exports = __webpack_public_path__ + "static/media/s11 — kopia.52fb9851.jpg";